import { IQuickSummaryProps } from "./QuickSummary";

export const View = (props: IQuickSummaryProps) => {
  return (
    <div className="quicksummary flex-container col">
      <div className="flex-box flex-container">
        <div className="font-ctm--semibold">{props.title}</div>

        <div
          className="quicksummary-icon--container align-icon--center"
          style={{ backgroundColor: props.iconBackground }}
        >
          {props.icon}
        </div>
      </div>

      <div>
        <h4 className="font-ctm--bold">{props.value}</h4>
      </div>
    </div>
  );
};
